<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <template>
            <div id="user-edit-tab-info">
              <!-- In SAGA (SagaX1n, or the old robot): the API refuses to change what SAGA holds (api/app/helpers/sagaLock.js). -->
              <vs-alert v-if="operation_data.issyncsaga === true" color="warning" active="true" icon-pack="feather" icon="icon-lock" class="mt-4 mb-2">
                This invoice is in SAGA<template v-if="operation_data.saga_sent_at"> since {{ new Date(operation_data.saga_sent_at).toLocaleDateString('en-GB', { timeZone: 'Europe/Bucharest' }) }}</template>:
                its customer, date, number, billing address, VAT and lines can no longer be changed here.
              </vs-alert>
              <!-- Content Row -->
              <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vx-input-group class="mt-4">
                        <template slot="prepend">
                          <div class="prepend-text bg-primary">
                            <span>Invoice Number</span>
                          </div>
                        </template>
                        <vs-input v-model="dataInvoiceNr" disabled size="default" />
                      </vx-input-group>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                      <vx-tooltip title="Do you really want to regenerate the invoice number?" color="warning"
                        text="If you want to change the Year, please edit the invoice date before!">
                        <vs-button class="w-full mt-2" type="border" color="warning" icon-pack="feather"
                          icon="icon-check" :disabled="sagaLocked" @click="getNewInvoiceNr()">
                          <font style="font-size: 12px">Regenerate</font>
                        </vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="dataInvoiceNr" class="vx-col md:w-1/3 w-full">
                      <vs-button class="w-full mt-2" type="border" color="danger" :disabled="sagaLocked" @click="setInvoiceNrMoinsUn()">
                        <font style="font-size: 12px">Number-1</font>
                      </vs-button>
                    </div>
                    <div v-if="dataInvoiceNr" class="vx-col md:w-1/3 w-full">
                      <vs-button class="w-full mt-2" type="border" color="success" :disabled="sagaLocked" @click="setInvoiceNrPlusUn()">
                        <font style="font-size: 12px">Number+1</font>
                      </vs-button>
                    </div>
                  </div>
                  <p class="w-full mt-4" style="font-size: 85%">
                    &nbsp;Invoice Date
                    <datepicker :inline="false" v-model="operation_data.date" :disabled="sagaLocked"></datepicker>
                  </p>
                  <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/2 w-1/2">
                      <div style="font-size: 85%">Payment Status</div>
                      <v-select :options="data_option_payment_status" v-model="statusId" />
                    </div>
                    <div class="vx-col md:w-1/2 w-1/2">
                      <span class="w-full" style="font-size:85%">
                        &nbsp;Payment Method
                        <v-select :options="data_payment_type" v-model="operation_data.ispaidbypos"
                          :reduce="option => option.value" label="label" />
                      </span>
                    </div>
                  </div>
                  <div class="vx-row mt-4" v-if="statusId && statusId.label !== 'Paid'">
                    <div class="vx-col md:w-1/2 w-1/2">
                      <vs-checkbox v-model="dataDispute">Dispute</vs-checkbox>
                    </div>
                    <div class="vx-col md:w-1/2 w-1/2" v-if="dataDispute">
                      <vs-input
                        v-model="dataDisputeComment"
                        label="Dispute Comment"
                        placeholder="e.g. Client dissolved company, bankruptcy..."
                        class="w-full"
                      />
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <div class="w-full mt-0">
                    <div class="w-full mt-0">
                      <div style="font-size: 85%">Client</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select autocomplete :options="data_option_people_name" v-model="personId" :disabled="sagaLocked"
                            @input="getBillingAndDeliveryAddressList(true)" />
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-4">
                      <div style="font-size: 85%">
                        Billing Address
                        <span v-if="addressesLoading" class="text-warning ml-2" style="font-size: 90%">(loading...)</span>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select autocomplete :disabled="addressesLoading || sagaLocked" :options="data_option_billing_address" v-model="billingAddressId" />
                          <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                               choisir une adresse quelconque du client a sa place. -->
                          <span v-if="billingAddressUnlinked" class="text-warning text-sm">No billing address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-4">
                      <div style="font-size: 85%">
                        Delivery Address
                        <span v-if="addressesLoading" class="text-warning ml-2" style="font-size: 90%">(loading...)</span>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select autocomplete :disabled="addressesLoading" :options="data_option_delivery_address" v-model="deliveryAddressId" />
                          <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                               choisir une adresse quelconque du client a sa place. -->
                          <span v-if="deliveryAddressUnlinked" class="text-warning text-sm">No delivery address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                        </div>
                      </div>
                    </div>
                    <div class="vx-row mt-8">
                      <div class="vx-col w-full">
                        <span class="w-full" style="font-size:85%">
                          Broker
                        <v-select disabled autocomplete :options="data_option_people_name" v-model="operation_data.idbroker" :reduce="option => option.value" label="label" />
                        </span>
                      </div>
                   </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <div class="vx-col md:w-full">
                  </div>
                  <div class="vx-col w-full mt-0">
                    <div style="font-size: 85%">Incoterms</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select :options="incotermOptions" v-model="IncotermId" @input="onIncotermInput" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-full mt-2" v-if="IncotermId.value == 'CPT - Carriage Paid To'">
                    <div style="font-size: 85%">Incoterms Clause Location</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-input v-model="dataIncotermsDest" class="w-full"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-full mt-4">
                    <div class="vx-row">
                      <div class="vx-col w-1/3 mt-0">
                        <div style="font-size: 85%">VAT (%)</div>
                        <vs-input v-validate="'required|decimal'" v-model="dataTva" class="w-full" name="tva" :disabled="sagaLocked" />
                        <span v-show="errors.has('tva')" class="text-danger">{{
                          errors.first("tva")
                        }}</span>
                        <vs-button class="mt-2" size="small" type="border" icon-pack="feather" icon="icon-refresh-cw"
                          :disabled="sagaLocked" @click="recomputeTva">Recalculate VAT</vs-button>
                      </div>
                      <div class="vx-col w-2/3 mt-0">
                        <div></div>
                        <vs-alert v-if="dataTva == '0'" color="warning" title="Warning" active="true">Exempt from
                          VAT.</vs-alert>
                        <vs-alert v-else color="primary" title="Information" active="true">Applicable VAT of {{ dataTva
                          }}%.</vs-alert>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <template>
                <div id="data-list-list-view" class="data-list-container">
                  <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
                    :data="sidebarData" />

                  <vs-table ref="table" :data="products">
                    <div slot="header" class="
                        flex flex-wrap-reverse
                        items-center
                        flex-grow
                        justify-between
                      ">
                      <div class="
                          flex flex-wrap-reverse
                          items-center
                          data-list-btn-container
                        ">
                        <!-- ACTION - DROPDOWN -->

                        <!-- ADD NEW -->
                        <div v-if="
                          !operation_data.iscreditnote &&
                          !operation_data.isadvanceinvoice &&
                          !sagaLocked
                        " class="
                            btn-add-new
                            p-3
                            mb-4
                            mr-4
                            rounded-lg
                            cursor-pointer
                            flex
                            items-center
                            justify-center
                            text-lg
                            font-medium
                            text-base text-primary
                            border border-solid border-primary
                          " @click="addNewData">
                          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                          <span class="ml-2 text-base text-primary">Add Product</span>
                        </div>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th>#</vs-th>
                      <vs-th>Category Product</vs-th>
                      <vs-th>Name</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Unit Price (EUR/UoM)</vs-th>
                      <vs-th>Unit of Measure</vs-th>
                      <vs-th>Volume Unit (m3/UoM)</vs-th>
                      <vs-th>Volume Total (m3)</vs-th>
                      <vs-th>Price per m3 (EUR/m3)</vs-th>
                      <vs-th>Total Price (EUR)</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                            <p class="font-medium truncate">
                              {{ indextr + 1 }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">
                              {{ tr.productcategory.name_en }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p>{{ tr.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>
                              {{
                                Math.abs(
                                  tr.operations_products.quantity
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>

                          <vs-td>
                            <p>
                              {{
                                parseFloat(
                                  tr.operations_products.unit_price
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>

                          <vs-td>{{ tr.uomsreference.name_en }}</vs-td>

                          <vs-td>
                            <p v-if="tr.volume">
                              {{ Math.abs(tr.volume).toFixed(4) }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.volume">
                              {{
                                Math.abs(
                                  tr.volume * tr.operations_products.quantity
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p v-if="tr.volume">
                              {{
                                Math.abs(
                                  (tr.operations_products.quantity *
                                    tr.operations_products.unit_price) /
                                  (tr.volume *
                                    tr.operations_products.quantity)
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td>
                            <p>
                              {{
                                parseFloat(
                                  Math.abs(tr.operations_products.quantity) *
                                  tr.operations_products.unit_price
                                ).toFixed(4)
                              }}
                            </p>
                          </vs-td>
                          <vs-td class="whitespace-no-wrap" v-if="
                            tr.operations_products.idproduct != 4 ||
                            operation_data.isadvanceinvoice ||
                            displayExport != true
                          ">
                            <feather-icon v-if="tr.operations_products.idproduct != 4 && !sagaLocked" icon="EditIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                            <feather-icon v-if="
                              (tr.operations_products.idproduct != 4 ||
                              displayExport == true) && !sagaLocked
                            " icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                              @click.stop="deleteProduct(tr.id, tr.name)" />
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>

                <div v-if="
                  !operation_data.isadvanceinvoice &&
                  !operation_data.iscreditnote
                " class="vx-row">
                  <div class="vx-col md:w-full">
                    <div class="w-full mt-16 md:w-full">
                      <div style="font-size: 75%">Bottom Mail Template</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select :options="data_option_bottom_mail_template" v-model="bottomMailTemplateId"
                            @input="writeBottomMailTemplate()" />
                        </div>
                      </div>
                    </div>
                    <div class="w-full mt-0 md:w-full">
                      <vs-textarea style="height: auto" rows="10" class="w-full mt-10" label="Bottom mail"
                        v-model="operation_data.mail_bottom" />
                    </div>
                    * Additional details: <br />
                    - Number of Products (transformable in m3).<br />
                    - The link with the photos;<br />
                    - If the service groupage is on the invoice, the link about
                    groupage;<br />
                    - The incoterms. <br /><br />* Payment information: <br />
                    - If there is a VAT exemption;<br />
                    - If there is an advance payment or payment upon order.
                    <br /><br />
                  </div>
                  <!--
                  <div class="vx-col md:w-1/2 w-full mt-10">
                    <vs-textarea
                      style="height: auto"
                      rows="10"
                      class="w-full mt-10"
                      label="Bottom mail payment"
                      v-model="operation_data.mail_bottom_payment"
                    />
                  * Additional bottom mail payment information: <br/>   - If there is a VAT exemption;<br/>   - If there is an advance payment.
                  </div>  -->
                </div>
              </template>
              <!-- Save & Reset Button -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-4 flex flex-wrap items-center justify-end">
                    <vx-tooltip title="Do you really want to delete this invoice?" color="danger"
                      text="This action is definitive, if you are not sure, please contact your admin!">
                      <vs-button v-if="operation_data.isactive && displayExport != false" type="border" color="danger"
                        icon-pack="feather" icon="icon-trash" :disabled="sagaLocked" @click="confirmDeleteRecord">Disable</vs-button>
                      <vs-button v-else type="border" color="success" icon-pack="feather" icon="icon-trash"
                        @click="confirmEnableRecord">Enable</vs-button>&nbsp;&nbsp;
                      <vs-button v-if="operation_data.iscreditnote" type="border" color="danger" icon-pack="feather"
                        icon="icon-trash" :disabled="sagaLocked" @click="confirmDeleteCreditNoteRecord">Delete Credit Note</vs-button>
                    </vx-tooltip>
                    <!--<vs-button
                      type="border"
                      color="warning"
                      icon-pack="feather"
                      icon="icon-cpu"
                      @click="confirmTransformToSale"
                      >Transform to Sale</vs-button
                    >-->
                    <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || addressesLoading">Save
                      Changes</vs-button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </vx-card>

    <vs-popup
      :title="$t('Differs from source quotation')"
      :active.sync="differsPopupActive"
    >
      <div class="differs-popup-body">
        <div
          v-for="(row, idx) in differsRows"
          :key="idx"
          class="mb-4"
        >
          <div class="font-semibold">{{ $t(row.label) }}</div>
          <div class="pl-4">{{ $t('Quote') }}: {{ row.quote }}</div>
          <div class="pl-4">{{ $t('Invoice') }}: {{ row.invoice }}</div>
        </div>
        <div class="mt-4">
          {{
            differsRows.length > 1
              ? $t('Are you sure you want to save the invoice with values different from the quotation?')
              : $t('Are you sure you want to save the invoice with a value different from the quotation?')
          }}
        </div>
        <div class="flex justify-end mt-6">
          <vs-button color="danger" type="flat" class="mr-3" @click="differsPopupActive = false">
            {{ $t('Cancel') }}
          </vs-button>
          <vs-button color="warning" @click="_confirmDiffersSave">
            {{ $t('Save anyway') }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import { takePersonOption } from "@/helpers/personOption";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import addressSelection from "@/mixins/addressSelection";
import pricingZones from "@/mixins/pricingZones";
import moment from "moment";
import { hasFirewoodLine } from "@/helpers/firewood";

export default {
  mixins: [pricingZones, addressSelection],
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      dataIncotermsDest: null,
      // Choix explicite dans le sélecteur Incoterms : le défaut bois ne le touche plus.
      incotermTouched: false,
      // Dernière vente de bois du client, pour l'incoterm par défaut.
      firewoodIncotermHistory: null,
      displayExport: false,
      dataInvoiceNr: null,
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      producttodelete: null,
      statusId: null,
      data_option_payment_status: [],
      dataTva: null,
      // Vrai dès qu'une TVA est déjà enregistrée sur la facture : le calcul
      // automatique ne doit alors plus rien écraser (seul le bouton
      // « Recalculer la TVA » le peut, sur action explicite de l'utilisateur).
      storedTvaLocked: false,
      databroker: [],
      data_option_billing_address: [],
      data_option_delivery_address: [],
      billingAddressId: null,
      deliveryAddressId: null,
      mail_bottom: null,
      data_payment_type: [
        {
          value: null,
          label: "OP",
        },
        {
          value: false,
          label: "CASH",
        },
        {
          value: true,
          label: "POS",
        },
      ],
      data_option_bottom_mail_template: [
        {
          value: 1,
          label: "Devis Round Stakes English",
        },
        {
          value: 2,
          label: "Devis Round Stakes Français",
        },
        {
          value: 3,
          label: "Devis Round Stakes Română",
        },
        {
          value: 4,
          label: "Devis Round Stakes Deutsche",
        },
        {
          value: 5,
          label: "Devis Round Stakes Español",
        },
        {
          value: 6,
          label: "Devis Round Stakes Nederlands",
        },
      ],
      bottomMailTemplateId: null,
      IncotermId: {
        value: "DAP - Delivered at Place",
        label: "DAP - Delivered at Place",
      },
      CPTValue: "",
      dataAdvanceEur: 0,
      dataAdvancePct: 0,
      selectedVatNumber: null,
      selectedLanguage: null,
      dataDispute: false,
      dataDisputeComment: null,
      differsPopupActive: false,
      differsRows: [],
    };
  },
  computed: {
    // Dans SAGA : même verrou que l'écran facture interne (api/app/helpers/sagaLock.js).
    sagaLocked() {
      return !!(this.operation_data && this.operation_data.issyncsaga === true);
    },
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    // Choix explicite de l'utilisateur dans le sélecteur Incoterms.
    onIncotermInput() {
      this.incotermTouched = true;
    },
    // Dernière vente de bois de chauffage du client (API, mise en cache par client) :
    // un client livré (DAP, ex. Teodora Industry) garde son terme, pas FCA Teiu.
    async fetchFirewoodIncotermHistory() {
      const person =
        (this.personId && this.personId.value) ||
        (this.operation_data && this.operation_data.people && this.operation_data.people[0] && this.operation_data.people[0].id);
      if (!person) return null;
      if (this.firewoodIncotermHistory && this.firewoodIncotermHistory.person === person) {
        return this.firewoodIncotermHistory.data;
      }
      try {
        const r = await axios.get("/person/lastfirewoodincoterm/" + person, {
          params: { exclude: this.operation_data && this.operation_data.id },
        });
        this.firewoodIncotermHistory = { person, data: r.data };
        return r.data;
      } catch (e) {
        return null;
      }
    },
    // Facture de bois RO qui vient de recevoir « FCA Teiu » par défaut : un client
    // livré (dernière vente de bois en DAP, ex. Teodora Industry) garde son terme.
    async applyFirewoodIncotermHistory() {
      if (!this.IncotermId || this.IncotermId.value !== "FCA Teiu") return;
      const history = await this.fetchFirewoodIncotermHistory();
      if (this.incotermTouched || !this.IncotermId || this.IncotermId.value !== "FCA Teiu") return;
      if (history && history.incoterms && history.departure === false) {
        this.IncotermId = { value: history.incoterms, label: history.incoterms };
      }
    },
    // Sélectionne l'incoterm enregistré sur l'opération. Une valeur absente de la liste
    // (libellé de zone dynamique "DAP BENELUX", ancien "EXW"…) est CONSERVÉE telle quelle :
    // avant, elle tombait dans un else qui la réécrivait silencieusement en
    // "CPT - Carriage Paid To" dès le premier enregistrement.
    applyStoredIncoterm() {
      const stored = (this.operation_data && this.operation_data.incoterms)
        ? String(this.operation_data.incoterms).trim()
        : "";
      this.dataIncotermsDest = this.operation_data ? this.operation_data.incoterms_dest : null;
      if (!stored) {
        // Aucun incoterm enregistré : FCA par défaut pour les factures RO (Roumanie), DAP sinon
        const isRo = String((this.operation_data && this.operation_data.invoice_no) || "").toUpperCase().startsWith("RO");
        // Bois de chauffage RO : « FCA Teiu » (Ferdinand, 2026-10-09).
        const isRoFirewood = isRo && hasFirewoodLine(this.operation_data && this.operation_data.products);
        this.IncotermId = isRoFirewood
          ? { value: "FCA Teiu", label: "FCA Teiu" }
          : isRo
            ? { value: "FCA - Free Carrier", label: "FCA - Free Carrier" }
            : { value: "DAP - Delivered at Place", label: "DAP - Delivered at Place" };
        if (isRoFirewood) this.applyFirewoodIncotermHistory();
        return;
      }
      const known = (this.incotermOptions || []).filter((o) => o.value === stored)[0];
      if (known) {
        this.IncotermId = known;
        return;
      }
      // Anciennes écritures non canoniques : on recale sur l'option équivalente.
      if (stored.includes("Free")) {
        this.IncotermId = { value: "FCA - Free Carrier", label: "FCA - Free Carrier" };
      } else if (stored.includes("Carriage")) {
        this.IncotermId = { value: "CPT - Carriage Paid To", label: "CPT - Carriage Paid To" };
      } else if (stored.includes("Delivered at Place")) {
        this.IncotermId = { value: "DAP - Delivered at Place", label: "DAP - Delivered at Place" };
      } else {
        this.IncotermId = { value: stored, label: stored };
      }
    },
    // Taux de TVA enregistré sur la facture : première ligne dont tva_pct est
    // renseigné. On ne se contente pas de products[0], qui peut être une ligne
    // ajoutée après coup et laissée à NULL.
    readStoredTva() {
      const products =
        (this.operation_data && this.operation_data.products) || [];
      for (const product of products) {
        const raw = product.operations_products
          ? product.operations_products.tva_pct
          : null;
        if (raw === null || raw === undefined || raw === "") continue;
        if (!Number.isFinite(Number(raw))) continue;
        return raw;
      }
      return null;
    },
    // Applique la règle pays / bois de chauffage / exonération.
    // force = true uniquement depuis le bouton « Recalculer la TVA » : le taux
    // enregistré fait foi et n'est jamais réécrit automatiquement à l'édition.
    updateTvaForFirewood(productId = null, { force = false } = {}) {
      if (this.storedTvaLocked && !force) {
        return;
      }

      // Le document est « bois de chauffage » dès qu'UNE de ses lignes l'est.
      // On ne regarde plus products[0] : trié par id, une ligne Transport (1) ou
      // Advance (1692) y passait devant le bois et imposait 21 % à la facture.
      const lines = (this.operation_data && this.operation_data.products) || [];
      const isFirewood = hasFirewoodLine(lines, productId);
      const hasLines = lines.length > 0 || (productId !== null && productId !== undefined);
      
      // Vérifier si le client est en Roumanie
      let isRomania = false;
      if (this.billingAddressId && this.billingAddressId.label) {
        isRomania = this.billingAddressId.label.includes("Romania");
      } else if (this.data_option_billing_address && this.data_option_billing_address.length > 0) {
        const firstAddress = this.data_option_billing_address[0];
        if (firstAddress.label) {
          isRomania = firstAddress.label.includes("Romania");
        }
      }
      
      // Roumanie : si client a TVA valide (RO) → 0%, sinon 11% (bois) ou 21%
      if (isRomania && hasLines) {
        const person = this.operation_data && this.operation_data.people && this.operation_data.people[0];
        const hasValidRoVat = person && person.subject_vat && person.vat_number && String(person.vat_number).replace(/\s/g, "").toUpperCase().startsWith("RO");
        if (hasValidRoVat) {
          this.dataTva = "0";
        } else if (isFirewood) {
          this.dataTva = "11";
        } else {
          this.dataTva = "21";
        }
      }
    },
    // Seul chemin qui écrase une TVA enregistrée, et il est déclenché à la main.
    recomputeTva() {
      const before = this.dataTva;
      this.updateTvaForFirewood(null, { force: true });
      if (String(this.dataTva) === String(before)) {
        this.$vs.notify({
          color: "primary",
          title: "VAT unchanged",
          text: "The applicable rule still gives " + before + "%.",
        });
      } else {
        this.$vs.notify({
          color: "warning",
          title: "VAT recalculated",
          text: before + "% → " + this.dataTva + "%",
        });
      }
    },
    async getAllocatedBroker() {
      {
          axios
            .get("/people/data/" + this.personId.value)
            .then((response) => {
              this.operation_data.idbroker = response.data.idbroker;
              this.databroker = [...response.data];
            });
      }
    },
    testInvoiceNr() {
      alert("is free");
    },
    setInvoiceNrPlusUn() {
      var str = this.dataInvoiceNr;
      var res = str.split("_");
      var numberToIncrement = res[1];
      var result = parseInt(numberToIncrement) + 1;

      let number = null;
      str = "" + result;
      let pad = "00000";
      number = pad.substring(0, pad.length - str.length) + str;
      this.dataInvoiceNr = res[0] + "_" + number;
    },
    setInvoiceNrMoinsUn() {
      var str = this.dataInvoiceNr;
      var res = str.split("_");
      var numberToIncrement = res[1];
      var result = parseInt(numberToIncrement) - 1;

      if (result > 0) {
        let number = null;
        str = "" + result;
        let pad = "00000";
        number = pad.substring(0, pad.length - str.length) + str;
        this.dataInvoiceNr = res[0] + "_" + number;
      }
    },
    async getNewInvoiceNr() {
      axios
        .get(
          "/sale/getnextinvoicenr/" +
          moment(this.operation_data.date).add(12, "hours").format("YYYY") +
          ""
        )
        .then((response) => {
          try {
            if (this.data_option_billing_address[0].label.includes("Romania")) {
              this.dataInvoiceNr = response.data.next_invoice_no.ro;
              // Factures RO (Roumanie) : incoterm FCA par défaut, comme l'onglet
              // facture standard ; « FCA Teiu » pour le bois de chauffage.
              this.IncotermId = hasFirewoodLine(this.operation_data && this.operation_data.products)
                ? { value: "FCA Teiu", label: "FCA Teiu" }
                : { value: "FCA - Free Carrier", label: "FCA - Free Carrier" };
              this.applyFirewoodIncotermHistory();
            } else {
              this.dataInvoiceNr = response.data.next_invoice_no.eu;
            }
          } catch (error) { }
        })
        .catch((error) => { });
    },
    getBottomMailTemplate() {
      // Le garde testait this.mail_bottom (donnee de composant jamais alimentee),
      // pas le champ du document : il etait donc toujours vrai.
      if (
        this.operation_data.mail_bottom != null &&
        this.operation_data.mail_bottom !== ""
      )
        return;
      const ItemIndex = this.data_option_bottom_mail_template.findIndex(
        (p) => p.value === this.selectedLanguage
      );
      // Langue inconnue : findIndex renvoie -1, d'ou un bottomMailTemplateId
      // undefined sur lequel writeBottomMailTemplate() plantait.
      if (ItemIndex === -1) return;
      this.bottomMailTemplateId =
        this.data_option_bottom_mail_template[ItemIndex];
      this.writeBottomMailTemplate();
    },
    calculateAdvanceFromPctInput() {
      //if (this.m3difference)
      {
        this.$store
          .dispatch(
            "operationList/fetcheurdifference",
            this.$route.params.userId
          )
          .then((res) => {
            this.m3difference = res;
            /*this.dataAdvanceEur =
              (this.m3difference / 100) * this.dataAdvancePct;*/
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    calculateAdvanceFromEurInput() {
      //if (this.m3difference)
      {
        this.$store
          .dispatch(
            "operationList/fetcheurdifference",
            this.$route.params.userId
          )
          .then((res) => {
            this.m3difference = res;
            /*this.dataAdvancePct =
              (this.dataAdvanceEur / this.m3difference) * 100;*/
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    writeBottomMailTemplate() {
      if (this.bottomMailTemplateId.value === 1) {
        // EN
        this.operation_data.mail_bottom =
          "   - Wood species: Robinia Pseudoacacia.\n   - Straight poles, round, debarked, sharpened, diameter measured in the middle.\n   - Delivery only by full pallet.\n   - The Customer takes care of unloading the truck (a truck of 40 tons) and verifying the accessibility of the delivery address.\n   - Delivery time: 2-6 weeks (for groupage, it may take a little longer).";
        this.operation_data.mail_bottom_payment =
          "Payment:\n   - Payment upon order.";
      } else if (this.bottomMailTemplateId.value === 2) {
        // FR
        this.operation_data.mail_bottom =
          "   - Essence de bois: Robinia Pseudoacacia.\n   - Piquets écorcés, pointés, diamètre mesuré au milieu.\n   - Sauf exceptions, livraison uniquement par palette complète.\n   - Le Client s'occupe du déchargement du camion (semi-remorque de 40 tonnes) et de vérifier l'accessibilité de l'adresse de livraison.\n   - Délais de livraison: 2-6 semaines (pour les groupages, cela peut prendre un peu plus de temps).";
        this.operation_data.mail_bottom_payment =
          "Paiement:\n   - Paiement à la commande.";
      } else if (this.bottomMailTemplateId.value === 3) {
        // RO
        this.operation_data.mail_bottom =
          "   - Stalpi de salcam, rotunzi, decojiti si ascutiti.\n   - Diametru masurat la mijloc.\n   - Descărcarea camionului (40 tone) să fie efectuată de către client. De asemenea, el trebuie să verifice accesibilitatea la adresa de livrare. \n   - Timp de livrare:2-6 saptamani (pentru grupaj, poate dura mai mult).";
        this.operation_data.mail_bottom_payment =
          "Plată:\n   - Plata la comanda.";
      } else if (this.bottomMailTemplateId.value === 4) {
        // DE
        this.operation_data.mail_bottom =
          "   - Geschält und angespitzt Robinienholz.\n   - Durchmesser und Umfang in der Mitte gemessen.\n   - Lieferung nur mit voller Palette.\n   - Der Kunde kümmert sich um das Entladen des LKW (40-Tonnen-Sattelauflieger) und die Überprüfung der Zugänglichkeit der Lieferadresse.\n   - Lieferzeit: 2-6 Wochen ab Zahlungseingang (Bei Mengen unter einem vollen LKW kann es etwas länger dauern).";
        this.operation_data.mail_bottom_payment =
          "Zahlung:\n   - Zahlung bei der Bestellung.";
      } else if (this.bottomMailTemplateId.value === 5) {
        // ES
        this.operation_data.mail_bottom =
          "   - Esencia de madera: Robinia Pseudoacacia.\n   - Estacas descortezadas, puntiagudas, diámetro medido en el medio.\n   - Con algunas excepciones, entrega solo por palet completo.\n   - El Cliente se encarga de descargar el camión (semirremolque de 40 toneladas) y verificar la accesibilidad de la dirección de entrega.\n   - El tiempo de entrega: 2-6 semanas (para el transporte en grupaje, puede tardar un poco más).";
        this.operation_data.mail_bottom_payment =
          "Pago:\n   - El pago debe hacerse al realizar el pedido.";
      } else if (this.bottomMailTemplateId.value === 6) {
        // NL
        this.operation_data.mail_bottom =
          "   - Houtsoort: Robinia Pseudoacacia.\n   - Palen ontschorst, rond en gepunt, diameter gemeten in het midden.\n   - Behalve uitzonderingen, levering alleen per volle pallet.\n   - De klant zorgt voor het lossen van de vrachtwagen (vrachtwagen van 40 ton) en het verifiëren van de bereikbaarheid van het afleveradres.\n   - Levertermijn: 2-6 weken (voor bestellingen kleiner dan een volle vrachtwagen kan het wat langer duren).";
        this.operation_data.mail_bottom_payment =
          "Betaling:\n   - Betaling bij de bestelling.";
      }
    },
    // Les deux listes d'options d'abord (Promise.all), la selection ENSUITE.
    // Avant, la resolution de la selection etait lancee depuis chacun des deux
    // .then() : quatre requetes concurrentes, et la premiere tournait contre une
    // liste d'options encore vide. Deux vagues, un seul ordre possible.
    //
    // `personChanged` = le contact vient d'etre change dans le v-select. On ne
    // relit alors PAS l'adresse liee a l'operation : elle appartient encore a
    // l'ANCIEN contact, et la reinjecter dans les options du nouveau est
    // exactement le « l'adresse a saute » signale. On propose l'adresse par
    // defaut du nouveau contact, visible dans le v-select avant tout Save.
    async getBillingAndDeliveryAddressList(personChanged = false) {
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.billingAddressUnlinked = false;
      this.deliveryAddressUnlinked = false;
      this._beginAddressLoading();
      // Sans contact, il n'y a pas d'adresse a charger : ne pas dereferencer
      // this.personId.value (TypeError silencieux qui laissait le drapeau de
      // chargement a vrai, donc le bouton Save grise pour toujours).
      if (!this.personId || this.personId.value === null || this.personId.value === undefined) {
        this.data_option_billing_address = [];
        this.data_option_delivery_address = [];
        this._endAddressLoading();
        return;
      }
      try {
        const [billing, delivery] = await Promise.all([
          axios.get("/person/getaddressbilling/" + this.personId.value).catch(() => ({ data: [] })),
          axios.get("/person/getaddressdelivery/" + this.personId.value).catch(() => ({ data: [] })),
        ]);
        this.data_option_billing_address = [...((billing && billing.data) || [])];
        this.data_option_delivery_address = [...((delivery && delivery.data) || [])];
        await this.getSelectedBillingAndDeliveryAddressList(personChanged);
      } finally {
        this._endAddressLoading();
      }
    },
    async getPersonLanguageAndVATNumber() {
      {
        await axios
          .get("/people/data/" + this.personId.value)
          .then((response) => {
            this.selectedVatNumber = response.data.vat_number;
            this.selectedLanguage = response.data.language.id;
            // Le gabarit de bas de mail n'etait rempli que depuis le .catch() de
            // la recuperation d'adresse. Depuis que l'adresse se resout, cette
            // branche ne part plus : mail_bottom restait NULL et tout le bas du
            // PDF (details, paiement, CGV, signature) disparaissait. On l'ancre
            // ici, ou la langue dont il depend vient justement d'etre lue.
            this.getBottomMailTemplate();
          });
      }
    },
    // `personChanged` : voir getBillingAndDeliveryAddressList. Les deux
    // chaines sont RENVOYEES, donc reellement attendues par l'appelant —
    // avant, elles partaient en fire-and-forget et le drapeau de chargement
    // retombait a faux alors que les adresses n'etaient pas encore resolues.
    async getSelectedBillingAndDeliveryAddressList(personChanged = false) {
      const billingChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressbilling/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.billingAddressId = this.pickAddressOption(this.data_option_billing_address, selectedAddress);
            this.billingAddressUnlinked = false;
            // Vérifier si le produit est du "lemn de foc" et ajuster la TVA
            this.updateTvaForFirewood();
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.billingAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.billingAddressId) {
              this.billingAddressId = this.proposeAddressOption(this.data_option_billing_address);
              // Ne jamais écraser une TVA déjà enregistrée sur la facture : ce
              // repli ne sert qu'à proposer un taux pour un document neuf.
              if (!this.storedTvaLocked) {
                if (
                  this._firstAddressLabel(this.data_option_billing_address).includes("Romania")
                ) {
                  const person = this.operation_data.people[0];
                  const hasValidRoVat = person && person.subject_vat && person.vat_number && String(person.vat_number).replace(/\s/g, "").toUpperCase().startsWith("RO");
                  if (hasValidRoVat) {
                    this.dataTva = "0";
                  } else {
                    this.dataTva = "21";
                    this.updateTvaForFirewood();
                  }
                } else {
                if (this.operation_data.people[0].subject_vat) {
                  this.dataTva = "0";
                } else {
                  if (
                    this._firstAddressLabel(this.data_option_billing_address).includes(
                      "Belgium"
                    )
                  ) {
                    this.dataTva = "21";
                  } else {
                    // Repli hors RO/BE pour un document neuf. 19 % etait l'ancien
                    // taux roumain, mort depuis le passage a 21 % (reduit 11 %).
                    this.dataTva = "21";
                  }
                }
              }
              }
              /*if (
                this._firstAddressLabel(this.data_option_billing_address).includes("Romania")
              ) {
                this.dataTva = "21";
              } else {
                let iscompany = false;
                if (this.selectedVatNumber) iscompany = true;
                if (!iscompany) {
                  if (
                    this._firstAddressLabel(this.data_option_billing_address).includes(
                      "Belgium"
                    )
                  ) {
                    this.dataTva = "21";
                  } else if (
                    this._firstAddressLabel(this.data_option_billing_address).includes("France")
                  ) {
                    this.dataTva = "19";
                  } else if (
                    this._firstAddressLabel(this.data_option_billing_address).includes("Spain")
                  ) {
                    this.dataTva = "19";
                  } else if (
                    this._firstAddressLabel(this.data_option_billing_address).includes(
                      "Germany"
                    )
                  ) {
                    this.dataTva = "19";
                  } else if (
                    this._firstAddressLabel(this.data_option_billing_address).includes(
                      "Nederlands"
                    )
                  ) {
                    this.dataTva = "19";
                  }
                } else this.dataTva = "0";
              }*/
            }
            // getBottomMailTemplate() vivait ici : il ne partait donc que quand
            // l'adresse echouait. Il est appele depuis
            // getPersonLanguageAndVATNumber(), quel que soit le sort de l'adresse.
          });

      const deliveryChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressdelivery/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.deliveryAddressId = this.pickAddressOption(this.data_option_delivery_address, selectedAddress);
            this.deliveryAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.deliveryAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.deliveryAddressId)
              this.deliveryAddressId = this.proposeAddressOption(this.data_option_delivery_address);
          });

      return Promise.all([billingChain, deliveryChain]);
    },
    async getPaymentStatus() {
      axios.get("/salestatus/data").then((response) => {
        this.data_option_payment_status = [...response.data];
        if (this.operation_data.salestatus) {
          const ItemIndex = this.data_option_payment_status.findIndex(
            (p) => p.value === this.operation_data.salestatus.id
          );
          this.statusId = this.data_option_payment_status.splice(ItemIndex, 1);
        } else {
          this.statusId = this.data_option_payment_status.splice(2, 1);
        }
      });
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        // Le contact du document, même inactif — jamais le dernier de la liste (helpers/personOption).
        this.personId = takePersonOption(this.data_option_people_name, this.operation_data.people[0]);
        this.getBillingAndDeliveryAddressList();
        this.getReferencePrice();
        this.getPersonLanguageAndVATNumber();
      });
    },
    async getReferencePrice() {
      if (this.personId) {
        axios
          .get("/people/data/" + this.personId.value)
          .then((response) => {
            localStorage.setItem(
              "clientReferencePrice",
              response.data.ref_price
            );
            localStorage.setItem(
              "clientType",
              response.data.client_type
            );
          });
      }
    },
    confirmTransformToSale() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "Confirm Sale",
        text: `You are about to transform  ${namealert} to a Sale`,
        accept: this.transformToSale,
        acceptText: "Transform",
      });
    },
    deleteCreditNoteRecord() {
      axios
        .post("/operation/deleteCreditNote/", {
          idinvoice: this.operation_data.idinvoice_creditnote,
          idcreditnote: this.operation_data.id,
        })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/invoice/invoice-list" });
      this.showDeleteSuccess();
    },
    confirmDeleteCreditNoteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm DELETE",
        text: `You are about to DELETE the Credit Note`,
        accept: this.deleteCreditNoteRecord,
        acceptText: "DELETE",
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/broker/invoice/" + this.operation_data.id, query: { fromEdit: true } });
      this.showEnableSuccess();
    },
    // Les .catch vides masquaient tout echec de /operation/enable|disable :
    // l'ecran affichait « successfully deleted » et l'operation etait toujours la.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled",
      });
    },


    deleteRecord() {
      axios
        .post("/invoice/disable", { id: this.operation_data.id })
        .then((response) => {
          resolve(response)
        })
        .catch(() => { });
      this.$router.push({ path: "/broker/invoice/invoice-list" });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    editData(data) {
      /* this.$store.dispatch('operationList/updateOperation', obj).catch(err => { console.error(err) })*/
      data.idperson = this.operation_data.id;
      localStorage.setItem("clientId", this.personId.value);
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    addNewData() {
      if (this.operation_data.id) {
        localStorage.setItem("clientId", this.personId.value);
        var idoperation = this.operation_data.id;
        this.sidebarData = { idoperation };
        this.toggleDataSidebar(true);
      }
    },
    _addressLabel(addr) {
      if (!addr) return "—";
      const place = addr.place || {};
      const country = place.country || {};
      const parts = [
        [addr.street, addr.number].filter(Boolean).join(" "),
        [place.postal_code, place.place_name].filter(Boolean).join(" "),
        country.name_en,
      ].filter(Boolean);
      return parts.join(", ") || "—";
    },
    _brokerLabel(person) {
      if (!person) return "—";
      const fullName = [person.firstname, person.lastname].filter(Boolean).join(" ");
      return fullName || person.company_name || "—";
    },
    _findAddressLabelFromOptions(id, optionList) {
      if (id === null || id === undefined) return "—";
      const opt = (optionList || []).find((o) => o.value === id);
      return opt ? opt.label : String(id);
    },
    save_changes() {
      if (this.addressesLoading) {
        this.$vs.notify({
          color: "warning",
          title: "Please wait",
          text: "Addresses are still loading...",
        });
        return;
      }
      // Un champ TVA vide n'est pas une exonération : sans ce garde-fou le
      // backend écrivait 0% sur toutes les lignes de la facture.
      if (
        this.dataTva === null ||
        this.dataTva === undefined ||
        String(this.dataTva).trim() === "" ||
        !Number.isFinite(Number(this.dataTva))
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Missing VAT",
          text: "Enter a VAT percentage (0, 11, 21…) before saving.",
        });
        return;
      }
      const src = this.operation_data && this.operation_data.QuotationSource;
      if (!src) {
        this._performSave();
        return;
      }

      const formDelivery = this.deliveryAddressId ? this.deliveryAddressId.value : null;
      const formBilling = this.billingAddressId ? this.billingAddressId.value : null;
      const formBroker = this.operation_data.idbroker || null;
      const norm = (v) => (v === null || v === undefined || v === "" ? null : Number(v));

      const rows = [];
      if (norm(formDelivery) !== norm(src.idaddressdelivery)) {
        rows.push({
          label: "Delivery address",
          quote: this._addressLabel(src.DeliveryAddress),
          invoice: this._findAddressLabelFromOptions(formDelivery, this.data_option_delivery_address),
        });
      }
      if (norm(formBilling) !== norm(src.idaddressbilling)) {
        rows.push({
          label: "Billing address",
          quote: this._addressLabel(src.BillingAddress),
          invoice: this._findAddressLabelFromOptions(formBilling, this.data_option_billing_address),
        });
      }
      if (norm(formBroker) !== norm(src.idbroker)) {
        rows.push({
          label: "Broker",
          quote: this._brokerLabel(src.Broker),
          invoice: this._brokerLabel(this.operation_data.Broker),
        });
      }

      if (rows.length === 0) {
        this._performSave();
        return;
      }

      this.differsRows = rows;
      this.differsPopupActive = true;
    },
    _confirmDiffersSave() {
      this.differsPopupActive = false;
      this._performSave();
    },
    async _performSave() {
      /* eslint-disable */
      let ispaidbypos = null
      if (this.operation_data.ispaidbypos === true) ispaidbypos = 'TRUE'
      else if (this.operation_data.ispaidbypos === false) ispaidbypos = 'FALSE'
      else ispaidbypos = null

      let _idbilling = null;
      if (this.billingAddressId) {
        _idbilling = this.billingAddressId.value;
      }
      let _iddelivery = null;
      if (this.deliveryAddressId) {
        _iddelivery = this.deliveryAddressId.value;
      }

      let _incoterms = null;
      if (this.IncotermId) _incoterms = this.IncotermId.value;

      let incoterms_dest = null;
      if (this.dataIncotermsDest) incoterms_dest = this.dataIncotermsDest;


      const obj = {
        id: this.operation_data.id,
        idperson: this.personId.value,
        idsalestatus: this.statusId.value,
        date: moment(this.operation_data.date),
        tva: this.dataTva,
        mail_bottom: this.operation_data.mail_bottom,
        mail_bottom_payment: this.operation_data.mail_bottom_payment,
        iddelivery: _iddelivery,
        invoice_no: this.dataInvoiceNr,
        idbilling: _idbilling,
        incoterms: _incoterms,
        incoterms_dest: incoterms_dest,
        ispaidbypos: ispaidbypos,
        //acompte_amount: this.dataAdvanceEur,
        acompte_amount: this.dataAdvancePct,
        idbroker:this.operation_data.idbroker,
        who:localStorage.getItem("login-username"),
        dispute: this.dataDispute || false,
        dispute_comment: this.dataDisputeComment || null,
      };
      if (this.operation_data.id) {
        try {
          await this.$store.dispatch("operationList/updateOperation", obj);
        } catch (err) {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: "Save failed",
            // 409 « in SAGA » (api/app/helpers/sagaLock.js) : dire pourquoi.
            text: (err && err.response && err.response.data && err.response.data.message) || "The operation was NOT saved — PDF not generated.",
          });
          return; // ne pas naviguer vers un PDF potentiellement stale
        }

        this.$vs.notify({
          color: "success",
          title: "Operation Updated!",
          text: "The operation was successfully updated",
        });

        this.$router.push({ path: "/broker/invoice/" + this.operation_data.id, query: { fromEdit: true } });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The Product was successfully deleted",
      });
    },
    deleteProductOne() {
      const obj = {
        idproduct: this.producttodelete,
        idoperation: this.operation_data.id,
      };
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
      this.$store.dispatch("operationList/removeItem", obj).catch((err) => {
        console.error(err);
      });
      //refresh view after delete
      this.$store
        .dispatch("operationList/fetchm3difference", this.$route.params.userId)
        .then((res) => {
          //this.m3difference = res;
          //console.log(this.$store.state.operationList.m3difference)
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
      this.showDeleteAddressSuccess();
    },
    deleteProduct(id, name) {
      this.producttodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: "Delete Product",
      });
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then((res) => {
            this.operation_data = res.data;
            this.dataInvoiceNr = this.operation_data.invoice_no;
            this.dataDispute = this.operation_data.dispute || false;
            this.dataDisputeComment = this.operation_data.dispute_comment || null;
            this.getPeople();
            this.getPaymentStatus();
            // Le taux enregistré fait foi : s'il existe on le garde tel quel et
            // on verrouille tout recalcul automatique. Sinon (facture neuve ou
            // taux jamais renseigné) la règle pays/bois de feu peut proposer.
            const storedTva = this.readStoredTva();
            if (storedTva !== null) {
              this.dataTva = storedTva;
              this.storedTvaLocked = true;
            } else if (this.operation_data.products.length > 0) {
              this.updateTvaForFirewood();
            }
            this.applyStoredIncoterm();
            if (this.operation_data.acompte_amount) {
              this.dataAdvancePct = this.operation_data.acompte_amount;
              this.calculateAdvanceFromEurInput();
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
    fetch_product_data(userId) {
      if (userId) {
        this.$store.dispatch("operationList/fetchOperationProducts", userId);
        // this.$store.state.dataListProduct.products
        /*this.$store.dispatch('operationList/fetchOperationProducts', userId)
          .then(res => {
            this.product_data = res.data
            console.log(res)
            console.log(this.product_data)
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true
              return
            }
            console.error(err)
          })*/
      } else {
        this.product_data = {};
      }
    },
  },

  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user") || localStorage.getItem("login-roles").toLowerCase().includes("accountant")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_product_data(this.$route.params.userId);
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
